import Image from 'next/image';
import { Text } from '@pairy/pds-react';
import { MouseEvent } from 'react';

import * as Styled from './index.styles';

interface Props {
  fileThumbnail: string;
  handleFileThumbnailClick: () => void;
  isDragActive: boolean;
}

const ThumbnailButton = ({
  fileThumbnail,
  handleFileThumbnailClick,
  isDragActive,
}: Props) => {
  const handleThumbButtonClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handleFileThumbnailClick();
  };

  return (
    <Styled.Wrapper onClick={handleThumbButtonClick}>
      <Image src={fileThumbnail} layout="fill" objectFit="cover" />
      <Styled.Overlay alignItems="center" justifyContent="center">
        <Text variant="md-medium" color="white" textAlign="center">
          {isDragActive
            ? '여기에 놓아 업로드하세요.'
            : '클릭 또는 파일을 드래그하여 업로드하세요.'}
        </Text>
      </Styled.Overlay>
    </Styled.Wrapper>
  );
};

export default ThumbnailButton;
